import LazyLoad from 'lazyload';

let loadImages = () => {
    let images = document.querySelectorAll('.lazyload');
    new LazyLoad(images, {
        rootMargin: '300px 0px 0px 0px'
    });
    images.forEach(img => img.classList.remove('lazyload'));
};

export default loadImages;
